/** @format */

import { ChangeDetectionStrategy, Component, input, viewChild } from '@angular/core';
import { BypassSanitizationPipe } from '@shared/utils/pipes';
import { HmfAccordionComponent, HmfDrawerComponent } from '@dsg-tech/homefield-angular';
import {
	HomefieldIconLibraryModule,
	homefieldIconNatureWaves,
	HomefieldIconsLibraryService
} from '@dsg-tech/homefield-angular-icons';

@Component({
	selector: 'pdp-textile-label',
	templateUrl: './textile-label.component.html',
	styleUrl: './textile-label.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [HmfAccordionComponent, HomefieldIconLibraryModule, BypassSanitizationPipe]
})
export class TextileLabelComponent {
	readonly textileLabel = input.required<string>();

	// Convert to viewChild signal (optional query since drawer may not exist)
	protected readonly textileLabelDrawer = viewChild<HmfDrawerComponent>('textileLabelDrawer');

	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([homefieldIconNatureWaves]);
	}
}
